/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postPlatformActionUpdateClients } from '../fn/platform/post-platform-action-update-clients';
import { PostPlatformActionUpdateClients$Params } from '../fn/platform/post-platform-action-update-clients';

@Injectable({ providedIn: 'root' })
export class PlatformPlatformService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postPlatformActionUpdateClients()` */
  static readonly PostPlatformActionUpdateClientsPath = '/api/platform/action/update-clients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postPlatformActionUpdateClients()` instead.
   *
   * This method doesn't expect any request body.
   */
  postPlatformActionUpdateClients$Response(params?: PostPlatformActionUpdateClients$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postPlatformActionUpdateClients(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postPlatformActionUpdateClients$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postPlatformActionUpdateClients(params?: PostPlatformActionUpdateClients$Params, context?: HttpContext): Observable<void> {
    return this.postPlatformActionUpdateClients$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
